import Tracker from '@openreplay/tracker';

export const tracker = new Tracker({
  projectKey: process.env.REACT_APP_OPENREPLAY_PROJECT_KEY!,
  __DISABLE_SECURE_MODE: process.env.NODE_ENV === 'development',
});
